(function () {
    'use strict';
    var LEFT_NAV_MIN_HEIGHT = 760;
    var LEFT_NAV_GAP_BETWEEN_FOOTER_CONTENTS = 20;
    // Directives related to triggers
    angular.module('GorillaBoy.directives')
    .directive('onScrollEnd', [function() {
        var SCROLL_BOTTOM_MAX_IN_PX = 150;
        return {
            restrict: 'A',
            scope : {
                onScrollEnd: '&'
            },
            link : function($scope, $element, $attrs) {
                $element.on('scroll', function(evt) {
                    var el = $element.get(0);
                    var scrollTop = $element.scrollTop() || 0,
                        scrollHeight = el.scrollHeight,
                        containerHeight = el.offsetHeight;

                    if (scrollHeight - (scrollTop + containerHeight) < SCROLL_BOTTOM_MAX_IN_PX) {
                        $scope.onScrollEnd();
                    }
                });
            }
        };
    }])
    .directive('scrollContainerToFit', ['$timeout', function($timeout) {
        return {
            restrict : 'A',
            link : function($scope, $element, $attrs) {
                var el = $element.get(0);
                $timeout(function() {
                    var bcr = el.getBoundingClientRect();
                    var $overflownEl = getScrollableParent($element.parent());
                    var parentBcr = $overflownEl.get(0).getBoundingClientRect();
                    if (bcr.bottom > parentBcr.bottom) {
                        $overflownEl.scrollTop($overflownEl.scrollTop() + (bcr.bottom - parentBcr.bottom));
                    }
                }, 0, false);
            }
        };

        function getScrollableParent($el) {
            var $parent = $el.parent();
            //Traverse up the DOM chain until you find a overflown item or you hit the root DOM element
            if ($el.css('overflow-y') === 'auto' || $parent.length === 0) {
                return $el;
            } else {
                return getScrollableParent($el.parent());
            }
        }
    }])
    /**
     * You can use the following directive for binding enter key to perform some action
     * Also the Shirt + Enter would create new lines
     */
    .directive('enterKeyBinding', ['AppConstants', function(AppConstants) {
        return {
            restrict: 'A',
            require : 'ngModel',
            link : function($scope, $element, $attrs, ngModelCtrl) {
                $element.on('keydown', function(evt) {
                    if (evt.which === AppConstants.KeyCodes.ENTER && !evt.shiftKey) {
                        //Prevent default here to avoid having a new line in the input
                        evt.preventDefault();
                        //The reason we give blur is because we've 0ms for 'blur' for ngModelOptions so it
                        //binds immediately to the model in case of Enter key presses
                        ngModelCtrl.$setViewValue($element.val(), 'blur');
                        if ($attrs.enterKeyBinding) {
                            //$eval() does not trigger $digest() loop after evaluation
                            $scope.$evalAsync($attrs.enterKeyBinding);
                        }
                    }
                });
            }
        };
    }])
    .directive('gbRepositionFooter', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            link : function($scope, $element, $attrs) {
                $timeout(function() {
                    var cummlHeight = 0;
                    $element.find("> div, > ul").each(function() {
                        cummlHeight += angular.element(this).outerHeight();
                    });
                    cummlHeight += LEFT_NAV_GAP_BETWEEN_FOOTER_CONTENTS;
                    cummlHeight = Math.max(cummlHeight, LEFT_NAV_MIN_HEIGHT);
                    $element.css('min-height', cummlHeight + 'px');
                }, 0, false);
            }
        };
    }])
    .directive('alertFor', ['$rootScope', function ($rootScope) {
        // Bootstrap alert boxes
        // TODO (fxc) This pattern should be propagated throughout our application. Backwards propagate for inline errors.
        return {
            restrict: 'E',
            scope: {
                message: '='
            },
            link: function (scope, element, attrs) {
                scope.escapeHTML = $rootScope.escapeHTML;
            },
            template:
            '<div class="alert alert-error margintop" ng-show="message.length">' +
                '<button type="button" class="close" ng-click="message=\'\'"></button>' +
                '<span ng-bind="escapeHTML(message)"></span>' +
            '</div>'
        };
    }])
    .directive('groupAlert', ['$rootScope', function ($rootScope) {
        return {
            restrict: 'E',
            scope: {
                message: '='
            },
            link: function (scope, element, attrs) {
                scope.escapeHTML = $rootScope.escapeHTML;
            },
            template:
            '<div class="group-error" ng-show="message.length">' +
                '<span ng-bind="escapeHTML(message)"></span>' +
            '</div>'
        };
    }])
    .directive('clearOnChange', function () {
        // Clear an error message when this element is changed. Use in conjunction with alert-for directive
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                message: '=message'
            },
            link: function (scope, elm, attr) {
                scope.$watch(attr.ngModel, function (val, oldVal) {
                    scope.message = '';
                });
            }
        };
    })
    .directive('fadeIn', function() {
        return {
            restrict: 'A',
            link: function(scope, elm, attrs) {
                var duration = parseInt(attrs.fadeIn);
                if (isNaN(duration)) {
                    duration = 200;
                }
                elm = jQuery(elm);
                elm.hide();
                elm.fadeIn(duration);

                scope.fadeOut = function() {
                    elm.fadeOut(duration);
                };
            }
        };
    })
    .directive('errorSrc', ['$log', function ($log) {
        // Used to bind a src to a default src in the case of error
        return {
            link: function(scope,element, attrs) {
                element.bind('error', function() {
                    element.addClass('error-image');
                    element.attr('src', attrs.errorSrc);
                });
            }
        };
    }])
    .directive('gbFocus', ['$timeout', function($timeout) {
        // Deprecated and should be transitioned out.
        // Uses timeout to trigger an event.
        return {
            link: function(scope, element, attrs) {
                var timeoutCancelPromise,
                    FOCUS_TIMEOUT = 600; //Our bootstrap modals currently render slowly.

                if (attrs.timeout) {
                    FOCUS_TIMEOUT = attrs.timeout;
                }

                scope.$watch(attrs.gbFocus, function(newVal , oldVal) {
                    if (newVal) {
                        timeoutCancelPromise = $timeout(function() {
                            timeoutCancelPromise = null;
                            element[0].focus();
                        }, FOCUS_TIMEOUT, false);
                    }
                }, true);

                //Do not focus element when scope is destroyed, because the element will also be destroyed
                scope.$on('$destroy', function() {
                    if (timeoutCancelPromise) {
                        $timeout.cancel(timeoutCancelPromise);
                    }
                });
            }
        };
    }])
    .directive('gbFocusOn', ['$timeout', function ($timeout){
        return function (scope, element, attr) {
            scope.$on('gbFocus', function (event, name) {
                if (name === attr.gbFocusOn) {
                    $timeout(function () {
                        element[0].focus();
                    });
                }
            });
        };
    }])
    .directive('slideDown', function () {
        return {
            restrict: 'A',
            link: function(scope, elm, attrs) {

                attrs.$observe('slideDown', function (slideDown){
                    elm = jQuery(elm);
                    elm.hide();
                    if (slideDown > 0 && slideDown !== "") {
                        var duration = parseInt(attrs.duration);
                        if (isNaN(duration)) {
                            duration = 500;
                        }
                        elm.slideDown(duration);
                    } else {
                        elm.show();
                    }
                });

                scope.slideUp = function() {
                    elm.slideUp(duration);
                };
            }
        };
    })
    .directive('slideUp', function(){
        return {
            restrict: 'A',
            link: function(scope, elm, attrs) {
                attrs.$observe('slideUp', function (slideUp){
                    elm = jQuery(elm);
                    elm.hide();
                    if (slideUp > 0 && slideUp !== "") {
                        var duration = parseInt(attrs.duration);
                        if (isNaN(duration)) {
                            duration = 500;
                        }
                        elm.slideUp(duration);
                    } else {
                        elm.show();
                    }
                });

                scope.slideDown = function() {
                    elm.slideDown(duration);
                };
            }
        };
    })
    .directive('editInline', ['$timeout', '$rootScope', 'MessageManager', 'MessageProvider', 'FileService', 'SignalProvider', 'AppConstants',
        function ($timeout, $rootScope, MessageManager, MessageProvider, FileService, SignalProvider, AppConstants) {

        function disableEditing (scope, element, shouldResyncView) {
            element.off('mousedown keypress');
            $(document).off('mousedown keydown');

            if (shouldResyncView) {
                scope.$emit(SignalProvider.Folder.SyncCurrentView);
            } else {
                // only hide input box, no need to reload page.
                scope.$emit(SignalProvider.Folder.NotSyncCurrentView);
            }
        }

        function submitRenameRequest(scope, element, docOrFolder) {
            var newName = scope.itemname.value;
            FileService.updateName(docOrFolder, newName)
            .then(function() {
                disableEditing(scope, element, true);
            }, function() {
                disableEditing(scope, element, false);
            });
        }


        return {
            restrict: 'A',
            scope: {
                item: "=",
                itemname: "="
            },
            link: function(scope, element, attrs) {                
                scope.itemname.value = !!scope.item.VersionMetadata ? scope.item.VersionMetadata.Name : scope.item.Name;
                $timeout(function () {
                    if (!!scope.item.VersionMetadata) {
                        // if it has versions, it's a document. We only highlight document name (without extension).
                        var indexOfLastDot = scope.itemname.value.lastIndexOf(".");
                        element[0].setSelectionRange(0, indexOfLastDot);
                    } else {
                        // For folders we highlight the entire folder name
                        element[0].setSelectionRange(0, scope.itemname.value.length);
                    }
                    element.focus();

                    // Whenever the user clicks outside the input box or hits enter, we submit
                    element.on({
                        mousedown: function (evt) {
                            evt.stopPropagation();
                        },
                        keypress: function (evt) {
                            var keycode = evt.keyCode ? evt.keyCode : evt.which;
                            if (keycode == AppConstants.KeyCodes.ENTER) {
                                submitRenameRequest(scope, element, scope.item);
                            }
                        }
                    });

                    $(document).on('mousedown', mouseDownListener);
                    $(document).on('keydown', keydownListener);
                    scope.$on('$destroy', function() {
                        $(document).off('mousedown', mouseDownListener);
                        $(document).off('keydown', keydownListener);
                    });

                    function mouseDownListener() {
                        submitRenameRequest(scope, element, scope.item);
                    }

                    function keydownListener(evt) {
                        var keycode = evt.keyCode ? evt.keyCode : evt.which;
                        if (keycode == '27') { // "Escape" key
                            disableEditing(scope, element, true);
                        }
                    }
                // We need to wait a little while for the DOM element to show up before we can select it
                }, 0, false);
            }
        };
    }]);

}());
